var map = {
	"./basketball-active.webp": 1459,
	"./basketball.webp": 1460,
	"./bg.webp": 1461,
	"./football-active.webp": 1462,
	"./football.webp": 1463,
	"./games-active.webp": 1464,
	"./games.webp": 1465,
	"./information.webp": 1466,
	"./live-streaming-cover.webp": 1467,
	"./lv-active-bg.webp": 1468,
	"./video-bg.webp": 1469,
	"./video-icon.webp": 1470,
	"./vs.webp": 1471
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 464;